import { useEffect, useRef } from 'react';
import './SnapScrapTrustpilot.css';

const SCRIPT_SRC =
  'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export default function SnapScrapTrustpilot() {
  const trustboxRef = useRef(null);

  useEffect(() => {
    const el = trustboxRef.current;
    if (!el) return undefined;

    let cancelled = false;
    let tries = 0;
    let timer;

    const loadWidget = () => {
      if (cancelled || !trustboxRef.current) return;
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(trustboxRef.current, true);
        return;
      }

      tries += 1;
      if (tries < 40) {
        timer = window.setTimeout(loadWidget, 150);
      }
    };

    let script = document.querySelector(
      'script[src*="tp.widget.bootstrap.min.js"]'
    );

    if (!script) {
      script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      document.head.appendChild(script);
    }

    if (window.Trustpilot || script.readyState === 'complete') {
      loadWidget();
    } else {
      script.addEventListener('load', loadWidget);
    }

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      script.removeEventListener('load', loadWidget);
    };
  }, []);

  return (
    <div className="trustpilot-section">
      <div className="trustpilot-inner">
        <div
          ref={trustboxRef}
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="56278e9abfbbba0bdcd568bc"
          data-businessunit-id="6a7b4922969e3c549fa3215f"
          data-style-height="52px"
          data-style-width="100%"
          data-token="f5a1d14d-6f07-4b68-970a-402eec87205e"
        >
          <a
            href="https://www.trustpilot.com/review/snapscrap.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </div>
  );
}
